<template>
  <a
    v-if="record && record.url"
    :href="record.url"
    target="_blank"
    rel="noopener"
    class="inline-flex items-center gap-1.5 rounded-md border border-[#B8E3F6] bg-[#EEF8FD] px-2 py-0.5 text-[11px] font-semibold text-[#0B5CAB] no-underline hover:border-[#00A1E0] hover:bg-[#DDF1FB] transition-colors whitespace-nowrap"
    :title="`Open this ${record.kind} in Salesforce (${record.id})`"
    @click.stop
  >
    <svg viewBox="0 0 24 16" class="h-3 w-[18px] shrink-0" aria-hidden="true">
      <path fill="#00A1E0" d="M10 2.2A4.3 4.3 0 0 1 13.1 1c1.6 0 3 .9 3.8 2.2a5.2 5.2 0 0 1 2.1-.4c2.9 0 5 2.4 5 5.3S21.9 13.4 19 13.4c-.4 0-.7 0-1-.1a3.8 3.8 0 0 1-5 1.6 4.4 4.4 0 0 1-8.1-.4 3.4 3.4 0 0 1-.7.1C2 14.6 0 12.6 0 10.1c0-1.7.9-3.1 2.2-3.9A4.9 4.9 0 0 1 10 2.2Z" />
    </svg>
    {{ label || `Salesforce ${record.kind}` }}
    <font-awesome-icon :icon="['fas', 'arrow-up-right-from-square']" class="text-[9px]" />
  </a>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'SalesforceLink',
  components: { FontAwesomeIcon },
  props: {
    record: { type: Object, default: null },
    label: { type: String, default: '' },
  },
}
</script>
